<template>
<div class="modal-window">
    <header class="modal-header">
        <div class="tit">{{ $i18nUtil.trans("title.UserCheck.001", "본인 확인") }}</div>
        <button @click="$emit('close')" class="btn_close">X</button>
    </header>
    <div class="mbs003">
        <div class="modal-content">
            <div class="setp1" v-if="!hasOtp">
                <div class="input-box">
                    <input type="text" id="userId" name="userId" v-model="userId" v-validate="'required'" :placeholder="$i18nUtil.trans('message.UserCheck.001', '이메일')"/>
                    <!-- <button type="button" class="input-txt-del" @click="rmInput()">입력 삭제</button> -->
                    <div class="error-list">
                        <div class="error" v-if="errors.has('userId') ">{{ $i18nUtil.trans("UB017", "이메일 주소를 입력해주세요.") }}</div>
                    </div>
                </div>
                <div class="input-box">
                    <input type="input" id="cellPhoneNo" name="cellPhoneNo" v-model="cellPhoneNo" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.phoneNumber', '휴대폰번호')"/>
                    <!-- <button type="button" class="input-txt-del">입력 삭제</button> -->
                    <div class="error-list">
                        <div class="error" v-if="errors.has('cellPhoneNo') ">{{ $i18nUtil.trans("AG026", "휴대폰번호를 입력해주세요.") }}</div>
                    </div>
                </div>
            </div>
            <div class="setp2" v-if="hasOtp">
                <div class="input-box">
                    <input type="number" id="otp" name="otp" v-model="otp" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.otp','인증번호')" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                    <span class="time" v-if="countDown !== null">
                        <span>{{countDown}}</span>
                    </span>
                    <button type="button" class="btn-primary-small black" @click="requestOtp">{{ $i18nUtil.trans("button.re.send", "재전송") }}</button>
                    <div class="error-list">
                        <div class="error" v-if="errors.has('otp') ">{{ $i18nUtil.trans("UB044", "인증번호를 입력해주세요.") }}</div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="modal-footer">
            <div class="txtc" v-if="!hasOtp"><button type="button" class="btn-primary-medium black" @click="requestOtp">{{ $i18nUtil.trans("button.UserCheck.req.otp", "인증번호 요청") }}</button></div>
            <div class="txtc" v-if="hasOtp"><button type="button" class="btn-primary-medium black" @click="confirmOtp">{{ $i18nUtil.trans("button.confirm", "확인") }}</button></div>
            <dl class="win-fotter-info">
                <dt>{{ $i18nUtil.trans("message.UserCheck.007", "본인확인 사용법 안내") }}</dt>
                <dd>
                    <ul class="list">
                        <li>{{ $i18nUtil.trans("message.UserCheck.008", "외부사용자 계정(이메일)일 경우 이메일과 휴대폰번호를 입력하시고 인증번호 요청을 누르시면 협업시스템에 등록된 핸드폰 번호로 인증번호가 전송됩니다.") }}</li>
                        <li>{{ $i18nUtil.trans("message.UserCheck.009", "전송 받은 인증번호를 입력하시고 확인을 누르시면 본인 확인 절차 후 비밀번호 재설정 화면으로 이동합니다.") }}</li>
                        <li>{{ $i18nUtil.trans("message.UserCheck.010", "서클 계정일 경우 개인정보 변경/찾기는 서클에서 가능합니다.") }}</li>
                    </ul>
                </dd>
            </dl>
        </footer>
    </div>
</div>
</template>

<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    components : {
        Dialog
    },
    data() {
        return { 
            /* 아이디 & 핸드폰번호 */
            userId : "",
            cellPhoneNo : "",

            /* 인증 성공여부 */
            otp : "",
            otpId : "",
            hasOtp : false,
            isValidOtp : false,
            minutes: 0,
            secondes: 0,
            time: 300,
            timer : null,

            show: true,
            hide: false,
            error: true,
            isWinPop: true,
        };
    },
    computed: {
        countDown() {
            let time = this.time / 60;
            let minutes = parseInt(time);
            let secondes = Math.round((time - minutes) * 60);

            let min = minutes;
            let sec = secondes;
            if (min < 10) {
                min = "0" + min;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }
            return min + " : " + sec;
        }
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showDialog"]),
        /* 본인확인 OTP 발급 & 재발급 요청 */
        requestOtp() {
            this.$validator.validate().then(valid => {
                let obj = this;
                let reqData = {
                    url : "/api/auth/org/requestOtp",
                    method : "post",
                    params : {
                        userId : obj.userId,
                        cellPhoneNo : obj.cellPhoneNo,
                        otpId : obj.otpId,
                        otp : obj.resOtp,
                        otpKbn : "RENEWAL"
                    }
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function(res) {
                    if(res.errorCode != null) {
                        let errorCode = res.errorCode;
                        if(errorCode === "AUTH_NO_USER_INFO") {
                            //alert("이메일 또는 휴대폰번호를  잘못 입력하셨습니다.");
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                contents: obj.$i18nUtil.trans("AG027", "이메일 또는 휴대폰번호를 잘못 입력하셨습니다."),
                                button: obj.$i18nUtil.trans("button.confirm", "확인"),
                            }
                            obj.handleDialog(info);
                        } else if(errorCode === "AUTH_CANT_MODIFY_INTERNAL_PASSWORD") {
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                contents: obj.$i18nUtil.trans("AG035", "서클 계정일 경우 개인정보 변경/찾기는 서클에서 가능합니다."),
                                button: obj.$i18nUtil.trans("button.confirm", "확인"),
                            };
                            obj.handleDialog(info);
                        }
                    } else {
                        obj.resOtp = res.result.otp;
                        obj.otpId = res.result.otpId;
                        obj.hasOtp = true;
                        console.log("OTP 번호 : " + obj.resOtp)
                        obj.time = 300;
                        obj.handleCountDown();
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            contents: obj.$i18nUtil.trans("AG014", "인증번호가 전송되었습니다."),
                            button: obj.$i18nUtil.trans("button.confirm", "확인"),
                        };
                        obj.handleDialog(info);
                    }
                })
                .catch(function(err) {
                  console.log(err);
                });
            });
        },
        /* OTP 확인 요청 */
        confirmOtp() {
            if(this.time === 0) {
                let info = {
                    title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                    contents: this.$i18nUtil.trans("AG015", "인증번호 입력시간이 초과되었습니다.\n인증번호 재전송 후 다시 입력해주세요."),
                    button: obj.$i18nUtil.trans("button.confirm", "확인"),
                };
                this.handleDialog(info);
            } else {
                this.$validator.validate().then(valid => {
                    if(valid) {
                        let obj = this;
                        let reqData = {
                            url : "/api/auth/org/confirmOtp",
                            method : "post",
                            params : {
                                otpId : obj.otpId,
                                otp : obj.otp
                            }
                        };
                        obj
                        .COWORK_REST_SIMPLE_ACTION(reqData)
                        .then(function(res){
                            if(res.errorCode != null) {
                                let errorCode = res.errorCode;
                                if(errorCode === "AG017") {
                                    let info = {
                                        title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                        contents: obj.$i18nUtil.trans("AG017", "인증번호가 일치하지 않습니다.\n인증번호를 확인 후 다시 시도해주세요."),
                                        button: obj.$i18nUtil.trans("button.confirm", "확인"),
                                    };
                                    obj.handleDialog(info);
                                }
                            } else {
                                if(res.result) {
                                    let info = {
                                        title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                        contents: obj.$i18nUtil.trans("message.UserCheck.006", "인증되었습니다."),
                                        button: obj.$i18nUtil.trans("button.confirm", "확인"),
                                    };
                                    obj.handleDialog(info);
                                    obj.isValidOtp = res.result;
                                    obj.$emit("validOtp", {isValidOtp : res.result, userId : obj.userId, cellPhoneNo : obj.cellPhoneNo});
                                    obj.$emit('close');
                                }
                            }
                        })
                        .catch(function(err){
                            console.log(err);
                        })
                    }
                });
            }
        },
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
        /* 5분 카운트 다운 */
        handleCountDown(timer) {
            if(timer !== null) {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                if (this.time > 0) {
                    this.time--;
                } else {
                    clearInterval(this.timer);
                }
                }, 1000);
            } else {
                this.timer = setInterval(() => {
                if (this.time > 0) {
                    this.time--;
                } else {
                    clearInterval(this.timer);
                }
                }, 1000);
            }
        },
        rmInput() {
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/login/modal/UserCheck.vue